import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import APIHelper from "@giscon/utils.api-helper-esri";
import LayerStore from "@giscon/utils.layer-store";
import { observer } from "mobx-react";
import { CircularProgress, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";

const Identify = ({
  nls = {
    noData: "Keine Daten",
    error: "Es ist ein Fehler aufgetreten",
    title: "Identifizieren",
    // eslint-disable-next-line no-template-curly-in-string
    layerInfo: "Ausgewählter Layer:",
    // eslint-disable-next-line no-template-curly-in-string
    result: "Ergebnis: ${result} ${units}",
    enable: "Identifizieren auf der Map aktivieren",
    info: "Daten können mit einem Klick auf die Map abgerufen werden.",
    noLayer: "Momentan befindet sich kein identifizierbares Layer auf der Map.",
  },
  valueField = "Classify.Pixelwert",
  valueField_ = "Classify.Pixel Value",
  valueField2 = "Stretch.Pixelwert",
  valueField2_ = "Classify.Pixel Value",
  classifyValue = "Classify.Klassenwert",
  classifyValue_ = "Classify.Class value",

  CommunicationStore,
  setActive,
  active,
  setInactive = () => {
    // console.log("set Inactive is not set!!");
  },
  showOnMap = (mapPoint) => {
    // console.log("show identify result @ ", mapPoint);
    return () => {
      // console.log("unmounting identify result");
    };
  },
  style,
  layer = undefined,
}) => {
  const { mapStore } = RootStore;
  const [initiatedPopup, setInitiatedPopup] = useState(false);
  const [resultLoading, setResultLoading] = useState(false);
  const [error, setError] = useState(false);
  const [identifyResult, setIdentifyResult] = useState(null);
  const [handler, setHandler] = useState(null);
  const enabled = active;
  const [curMapPoint, setCurMapPoint] = useState(null);
  const { map, view } = LayerStore;

  const activeMapWidget = CommunicationStore.getMessagesToID({
    to: "activeMapWidget",
  })?.message;

  useEffect(() => {
    if (enabled) {
      CommunicationStore.addMessage({
        to: "activeMapWidget",
        message: "identify",
      });
      // console.log("activated");
    }
  }, [enabled]);

  useEffect(() => {
    if (activeMapWidget && activeMapWidget != "identify") {
      setActive(false);
      // console.log("deactivate");
    }
  }, [activeMapWidget]);

  const message = CommunicationStore.getMessagesToID({
    toId: "shownLayers",
  })?.message;
  const identifyLayer =
    layer || message?.layerInfos[message.layerInfos.length - 1]?.layer;
  const layerurl = identifyLayer?.url;
  const legendInfo = identifyLayer?.legendInfo; // to be used for classification value
  let projection = false;
  {
    const message = CommunicationStore.getMessagesToID({
      to: "filterAccess",
    })?.message;
    const { items = [], index = null } = message ? message("Zeitraum") : {};
    if (index !== null) {
      projection = !!items?.[index]?.projection;
    }
  }

  useEffect(() => {
    if (
      mapStore.popup &&
      !mapStore.popupOpened &&
      document.querySelector(".mobileIdentifyRoot")?.style?.display ===
        "none" &&
      curMapPoint &&
      identifyResult
    ) {
      if (initiatedPopup) {
        setActive(false);
        setCurMapPoint(null);
        setIdentifyResult(null);
      } else {
        setInitiatedPopup(true);
      }
    }
  }, [
    // mapStore.popup,
    // setActive,
    initiatedPopup,
    mapStore.popupOpened,
    curMapPoint,
    identifyResult,
  ]);

  useEffect(() => {
    if (enabled) {
      setInitiatedPopup(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (showOnMap && enabled && curMapPoint && identifyResult) {
      const handler = showOnMap(curMapPoint);
      setInitiatedPopup(false);
      return handler;
    }
    if (!enabled) {
      setCurMapPoint(null);
      setIdentifyResult(null);
    }
    return () => {};
  }, [curMapPoint, showOnMap, identifyResult, enabled]);

  const identify = (mapPoint, legendInfo) => {
    setResultLoading(true);
    setError();
    // showOnMap(mapPoint);
    APIHelper.identifyPointOnLayer(layerurl, mapPoint, map, view)
      .then((features) => {
        setResultLoading(false);
        if (features && features.length) {
          const attributes = APIHelper.getAttributes(features[0]);
          let value = attributes.hasOwnProperty(valueField)
            ? attributes[valueField]
            : attributes[valueField2];
          let novalue = true;
          if (projection && legendInfo) {
            if (attributes.hasOwnProperty(classifyValue)) {
              setIdentifyResult({
                projection: true,
                value:
                  legendInfo.legend[parseInt(attributes[classifyValue])].label,
              });
              novalue = false;
            } else {
              novalue = true;
            }
          }
          if (novalue || !projection) {
            const decPlaces = getLayerDecimalPlaces(message);
            setIdentifyResult({
              projection: false,
              value:
                value === "NoData"
                  ? undefined
                  : parseFloat(value.replace(",", ".")).toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: decPlaces,
                        maximumFractionDigits: decPlaces,
                      }
                    ),
            });
          }
        } else {
          setIdentifyResult({});
        }
        // debugger;
      })
      .catch((e) => {
        setResultLoading(false);
        setError(e);
        console.error(e);
        // debugger;
      });
  };

  const getLayerUnits = (message) => {
    const metaData =
      message?.layerInfos[message.layerInfos.length - 1]?.metaData;
    return metaData.units ? `[${metaData.units}]` : "";
  };

  const getLayerDecimalPlaces = (message) => {
    const metaData =
      message?.layerInfos[message.layerInfos.length - 1]?.metaData;
    return metaData.hasOwnProperty("Nachkommastellen")
      ? metaData.Nachkommastellen
      : 1;
  };

  const getLayerConstrains = (message) => {
    let res = "";
    const constraints =
      message?.layerInfos[message.layerInfos.length - 1]?.metaData.constraints;

    // Zeitraum
    if (constraints.Parameter) {
      res += constraints.Parameter + " ";
    }

    if (constraints.Zeitabschnitt) {
      res += "- " + constraints.Zeitabschnitt;
    }

    if (constraints.Szenario) {
      res += " (" + constraints.Szenario + ", " + constraints.Zeitraum + ")";
    } else {
      res += " (" + constraints.Zeitraum + ")";
    }

    // if (res) {
    //   res = res.substring(0, res.length - 3);
    // }
    return res;
  };
  useEffect(() => {
    if (handler) {
      handler.remove();
    }
    if (layerurl) {
      setInactive(false);
    } else {
      setInactive(true);
    }
    if (!enabled) {
      setHandler(null);
    } else if (layerurl) {
      setHandler(
        APIHelper.registerCustomClickHandlerOnMap(
          ({ mapPoint, screenPoint }) => {
            if (!map || !view) return;
            setCurMapPoint(mapPoint);
            if (mapPoint) {
              identify(mapPoint, legendInfo);
            }
          },
          map,
          view
        )
      );
    } else {
      setHandler(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layerurl, map, view, enabled, legendInfo]);
  // console.log("rasterStatistics", rasterValues);
  useEffect(() => {
    if (curMapPoint && layerurl) {
      identify(curMapPoint, legendInfo);
    }
  }, [layerurl, legendInfo]);

  return (
    <>
      {layerurl && resultLoading && <CircularProgress />}
      {layerurl && (
        <Box>
          <Typography>{nls.layerInfo}</Typography>
          <Typography>{getLayerConstrains(message)}</Typography>
        </Box>
      )}
      {layerurl && error && (
        <div>
          <ErrorIcon style={{ color: "red" }} />
          <div>{nls.error}</div>
        </div>
      )}
      {layerurl && !error && !resultLoading && identifyResult && (
        <Typography>
          {identifyResult.value !== undefined
            ? nls.result
                .replace(/\$\{result\}/gi, identifyResult.value + "")
                .replace(/\$\{units\}/gi, getLayerUnits(message))
            : nls.noData}
        </Typography>
      )}
    </>
  );
};

export default observer(Identify);
